import { Observable } from 'rxjs';
import { UserModel } from '@app/tpv/models/user.model';

/**
 * Filtros que viajan al API en la consulta de usuarios por comercio. Coinciden
 * con los query params que reconoce `/auth/users`.
 */
export interface StoreUsersSearchFilter {
  first_name?: string;
  last_name?: string;
  email?: string;
  status?: string;
  role_name?: string;
}

export type StoreUsersExportFormat = 'excel' | 'csv' | 'pdf';

export interface StoreUsersExportPayload {
  base64: string;
  fileName: string;
  mimeType: string;
}

/**
 * Port abstracto para acceder a los usuarios de un comercio. Las
 * implementaciones concretas (remote, mock) viven en `data/data-sources/*` y se
 * cablean vía DI en `app.config.ts`. La capa de presentación NUNCA debe
 * inyectar `HttpClient` ni un servicio que lo invoque directamente.
 */
export abstract class StoreUsersRepository {
  abstract getByMerchant(
    idMerchant: number,
    page?: number,
    limit?: number,
    filters?: StoreUsersSearchFilter
  ): Observable<UserModel[]>;

  abstract downloadExport(
    format: StoreUsersExportFormat
  ): Observable<StoreUsersExportPayload | null>;
}
